<template>
<li>
  <div
    :class="{bold: isFolder}"
    @click="toggle">
    <md-checkbox v-if="!isFolder"
      v-model="value[parentModel.name]"
      @change="valueChanged"
      :value="model.value">
      <span v-if="$te(`filters.value.${label}['${model.name}']`)">
        {{ $t(`filters.value.${label}['${model.name}']`) }}
      </span>
      <span v-else>
        {{ model.value }}
      </span>
    </md-checkbox>
    <span v-else>
      <md-checkbox
        v-model="selected"
        @change="folderValueChanged" />
      <span class="pos-r" style="top: -5px;" @click="toggle">
        <span class="ml-1" @click="toggle">
          <span v-if="$te(`filters.value.${label}['${model.name}']`)">
            {{ $t(`filters.value.${label}['${model.name}']`) }} ({{ childrenSelected }})
          </span>
          <span v-else>
            {{ model.value }} ({{ childrenSelected }})
          </span>
        </span>
        <span class="ml-1" @click="toggle">
          <md-icon v-if="open">arrow_drop_up</md-icon>
          <md-icon v-else>arrow_drop_down</md-icon>
        </span>
      </span>
    </span>
  </div>
  <ul v-if="isFolder" v-show="open">
    <input-tree-item
      class="item"
      v-for="(childModel, index) in model.children"
      @valueChange="childValueChanged"
      :key="index"
      :model="childModel"
      :parentModel="model"
      :value.sync="value"
      :label="label">
    </input-tree-item>
  </ul>
</li>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'InputTreeItem',
  props: {
    label: String,
    value: Object,
    model: Object,
    parentModel: Object
  },
  data: () => ({
    selected: false,
    open: false,
    selectAll: true,
    childrenSelected: 0
  }),
  mounted () {
    const num = this.countChildrenSelected()
    this.childrenSelected = num
    this.open = num > 0
  },
  computed: {
    isFolder: function () {
      return this.model.children && this.model.children.length
    }
  },
  methods: {
    toggle () {
      if (this.isFolder) this.open = !this.open
    },
    valueChanged () {
      this.$emit('valueChange')
    },
    folderValueChanged () {
      const vm = this
      if (vm.model.children && vm.model.children.length > 0) {
        const childrenValues = _.map(vm.model.children, 'value')
        const currentValues = vm.value[vm.model.name]
        const selectAll = vm.selected
        vm.childrenSelected = selectAll ? childrenValues.length : 0
        vm.value[vm.model.name] = selectAll
          ? _.union(currentValues, childrenValues)
          : _.difference(currentValues, childrenValues)
        vm.$emit('filterValueChanged')
      }
    },
    childValueChanged () {
      this.childrenSelected = this.countChildrenSelected()
      this.$emit('filterValueChanged')
    },
    countChildrenSelected () {
      const vm = this
      const currentValues = vm.value[vm.model.name]
      const num = (currentValues) ? currentValues.length : 0
      if (num > 0) vm.selected = true
      else vm.selected = false
      return num
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  cursor: pointer;
}
.bold {
  font-weight: bold;
  margin: 6px 0 2px 0;
  cursor: pointer;
}
ul {
  margin: 0;
  padding: 0;
  padding-left: 24px;
  list-style: none;
}
.md-checkbox {
  margin: 4px 0;
}
</style>
